import { LitElement, html, css } from 'lit'

export class OfferDrawer extends LitElement {
  static styles = [
    css`
      .offer-column {
        display: flex;
        flex-direction: column;
        height: 100%;
      }
      .offer-container {
        background-color: #f4f4f2;
        padding: 20px;
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      .offer-header {
        background-color: #ffffff;
        padding: 8px 20px;
        font-family: 'ABC Oracle', 'Arial', 'Helvetica', 'sans-serif';
        font-weight: 400;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: 0%;
        color: #0a0a0a;
      }

      .offer-title {
        color: #0a0a0a;
        font-family: 'ABC Arizona Flare', 'serif';
        font-weight: 500;
        font-size: 20px;
        line-height: 100%;
        letter-spacing: 0%;
        vertical-align: middle;
        margin-bottom: 20px;
      }

      .offer-card {
        font-family: 'ABC Oracle', 'Arial', 'Helvetica', 'sans-serif';
        background-color: #ffffff;
        border-radius: 2px;
        box-shadow: 0px 0px 10px 0px #0000001a;
        padding: 20px;
        font-size: 14px;
        line-height: 150%;
        letter-spacing: 0%;
        vertical-align: middle;
        margin-bottom: 20px;
      }

      .offer-card ul {
        list-style: none;
        padding-left: 0px;
        margin-bottom: 8px;
        margin-top: 0;
      }

      .offer-card ul li {
        font-family: 'ABC Oracle', 'Arial', 'Helvetica', 'sans-serif';
        font-weight: 300;
        font-size: 14px;
        line-height: 150%;
        letter-spacing: 0%;
        vertical-align: middle;
      }

      .weight-normal {
        font-weight: 400;
      }

      .offer-card p {
        margin: 0;
      }

      .offer-question {
        color: #0a0a0a;
        font-family: 'ABC Arizona Flare', 'serif';
        font-weight: 500;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: 0%;
        vertical-align: middle;
        margin-bottom: 8px;
      }

      .offer-answer {
        color: #0a0a0a;
        font-family: 'ABC Oracle', 'Arial', 'Helvetica', 'sans-serif';
        font-weight: 300;
        font-size: 14px;
        line-height: 150%;
        letter-spacing: 0%;
        vertical-align: middle;
        margin: 0 0 20px 0;
      }

      .offer-code {
        color: #077f61;
        font-weight: 400;
      }

      .offer-conditions-title {
        color: #626261;
        font-family: 'ABC Oracle', 'Arial', 'Helvetica', 'sans-serif';
        font-size: 12px;
        line-height: 150%;
        letter-spacing: 0%;
        vertical-align: middle;
        font-weight: 400;
        margin-top: auto;
        margin-bottom: 8px;
      }

      .offer-conditions {
        color: #626261;
        font-family: 'ABC Oracle', 'Arial', 'Helvetica', 'sans-serif';
        font-weight: 300;
        font-size: 12px;
        line-height: 150%;
        letter-spacing: 0%;
        vertical-align: middle;
        font-weight: 300;
        margin: 0;
      }
    `,
  ]

  connectedCallback() {
    super.connectedCallback()
    window.MicroBus.on(`offer-drawer:open`, () => {
      const data = {
        overlayStyle: document.querySelector('#side-cart').hasAttribute('open') ? 'transparent' : '',
      }
      window.MicroBus.emit('offer-drawer:toggle', data)
    })
  }
  disconnectedCallback() {
    super.connectedCallback()
    window.MicroBus.off(`${this.id}:toggle`)
  }

  _openOffer(detail) {
    window.MicroBus.emit('offer-drawer:open')
  }

  _closeOffer() {
    window.MicroBus.emit('offer-drawer:toggle')
  }

  render() {
    return html`
      <div class="offer-column">
        <div class="offer-header">Offer Details</div>
        <div class="offer-container">
          <div class="offer-title">Buy More, Save More with code MYPLAN</div>
          <div class="offer-card">
            <ul>
              <li>1 subscription item <span class="weight-normal">→ 20% off first month</span></li>
              <li>2 subscription items <span class="weight-normal">→ 25% off first month</span></li>
              <li>3+ subscription items <span class="weight-normal">→ 30% off first month</span></li>
            </ul>
            <p>Use code <span class="offer-code">MYPLAN</span> in checkout. Applies to subscription products only.</p>
          </div>
          <div class="offer-question">Can I use the discount on Plans?</div>
          <p class="offer-answer">
            Yes! Needed Plans give you the best long term savings since they have additional ongoing monthly discounts that
            increase with the number of products in the Plan.
          </p>
          <p class="offer-answer">
            The MYPLAN discount can be applied to plans, which are counted as a single item, for an extra 20–30% off your
            first order.
          </p>
          <div class="offer-conditions-title">Terms and conditions</div>
          <p class="offer-conditions">
            Limit to one per customer. The offer code applies to the first billing of a new subscription. This code cannot be
            used on one-time purchases, cannot be combined with other offers, cannot be applied to quantities of three or
            more of the same item, and cannot be applied to more than 20 total items in cart.
          </p>
        </div>
      </div>
    `
  }
}

customElements.define('offer-drawer', OfferDrawer)
